/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Button,
  Col,
  Form,
  Pagination,
  Popconfirm,
  Row,
  Tag,
  Tooltip,
} from "antd";
import { useState, useRef } from "react";
import { Input, Table, Select } from "antd";
// import Sidebar from "../../../components/AdminComponents/SideNav";
// import { useParams } from "react-router-dom";
// import {
//   ClientMenu,
//   SecondaryNavClient,
// } from "../../../components/AdminComponents/MenuItems";

import {
  DeleteTwoTone,
  // CheckOutlined,
  PlusOutlined,
  MinusOutlined,
  // PlusCircleOutlined,
  CloseOutlined,
  CheckCircleFilled,
  SwapOutlined,
  CheckOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import "../../../pages/Admin-pages/tableStyling.css";
// import ExpanedFirstRow from "./ExpandedFirstRow";
import EditableImage from "../../icons/EditIcon";
import Axios from "../../../api/Axios";
import { useSelector } from "react-redux";
import "./modalstyles.css";
import { getUpdateStatus } from "../ViewUpdateIndex";
import {
  capitalizeWords,
  formatDateWithSuffix,
  remainingViewportHeight,
} from "../../icons/ApplicationColor";
import SubCategoryChild from "./SubCategoryChild";

const CategoryParent = (props) => {
  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus(userInfo, 0, 4) || true;
  //console.log(props.manager);

  //   const [top, setTop] = useState(false);

  // const handleParentRowClose = (key) => {
  //   setExpandedRows({
  //     ...expandedRows,
  //     [key]: true,
  //   });
  // };
  // const [secondRowIndex, setsecondRowIndex] = useState(-1);
  // const setRowSecond = (index) => {
  //   setsecondRowIndex(index);
  // };
  //

  // eslint-disable-next-line no-unused-vars
  const expandIcon = ({ expanded, onExpand, record }) =>
    expanded ? (
      <MinusOutlined onClick={(e) => onExpand(record, e)} />
    ) : (
      <PlusOutlined onClick={(e) => onExpand(record, e)} />
    );
  const [form] = Form.useForm();

  const [editingKey, setEditingKey] = useState("");
  const [initialHirearchy, setInitialHirearchy] = useState("");

  const [form1] = Form.useForm();
  const isEditing = (record) => record.id === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      ...record,
      manager: record?.manager?.id,
    });
    setEditingKey(record.id);
    setInitialHirearchy(record?.entity_id);
  };
  const cancel = () => {
    setEditingKey("");
  };
  const deleteRecord = (record) => {
    onDelete(record, "level_1");
  };

  const restoreRecord = (record) => {
    onRestore(record);
  };

  const onRestore = async (record) => {
    const data = {
      id: record.id,
      status: true,
      organization: userInfo.data.organization.id,
      name: record.name,
      updated_by: userInfo?.data?.id,
    };
    try {
      await Axios.put(`/categoryedit/${record.id}/`, data, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      cancel();
      props.CreateSuccessful("Category has been edited");
    } catch (err) {
      //console.log(err);
      props.CreateFailed(
        err?.response?.data?.detail || "Category status has not been edited"
      );
    }
  };

  // eslint-disable-next-line no-unused-vars
  const [applications, setApplications] = useState([]);
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode =
      inputType === "select" ? (
        <Select placeholder="Select Manager" disabled={!props.active}>
          <Select.Option key={"null"} value={"none"}>
            None
          </Select.Option>
          {props.manager?.map((app) => (
            <Select.Option key={app.id} value={app.id}>
              {app.full_name}
            </Select.Option>
          ))}
        </Select>
      ) : (
        <Input disabled={!props.active} />
      );

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            rules={
              dataIndex === "entity_id"
                ? [
                    {
                      validator: checkUserExists2,
                      validateTrigger: "onChange",
                    },
                  ]
                : dataIndex !== "manager"
                ? [
                    {
                      required: true,
                      message: `Please Input ${title}!`,
                    },
                  ]
                : undefined // ✅ explicitly set undefined for 'manager'
            }
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  // eslint-disable-next-line no-unused-vars
  const onDelete = async (record, type) => {
    try {
      await Axios.delete(
        `/categorydelete/?category_id=${record?.id}&type=${type}`,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      cancel();
      props.CreateSuccessful("Delete Successful");
    } catch (err) {
      //console.log(err);
      props.CreateFailed(err?.response?.data?.detail || "Delete Failed");
    }
  };

  // eslint-disable-next-line no-unused-vars
  const onFinish21 = async (values) => {
    const row = await form.validateFields();
    row.id = values.id;
    row.status = true;
    row.organization = userInfo.data.organization.id;
    row.created_by = userInfo?.data?.id;
    console.log(row);
    try {
      await Axios.put(`/categoryedit/${values.id}/`, row, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      cancel();
      props.CreateSuccessful("Category has been edited");
    } catch (err) {
      //console.log(err);
      props.CreateFailed(
        err?.response?.data?.detail || "Category status has not been edited"
      );
    }
  };

  const handleRowClick = (record) => {
    // Navigate to the details page using React Router
    edit(record);
  };
  const columns = [
    {
      title: capitalizeWords("category"),
      dataIndex: "name",
      key: "name",
      width: 170, // set width to 150px
      editable: true,
    },
    {
      title: capitalizeWords("Sub Categories"),
      dataIndex: "second_categories",
      key: "second_categories",
      width: 120, // set width to 150px
      align: "center",
      render: (second_categories) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center", // Center horizontally
            alignItems: "center", // Center vertically
          }}
        >
          <Tag
            color="purple"
            style={{
              fontSize: "1.15rem",
              width: "2.5rem",
              height: "2.5rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "50%", // Make it a circle
              fontWeight: "600",
              padding: 0, // Remove padding for a perfect circle
            }}
          >
            {second_categories?.length || 0}
          </Tag>
        </div>
      ),
    },
    {
      title: capitalizeWords("No. Of Courses"),
      dataIndex: "courses",
      key: "courses",
      width: 150, // set width to 150px
      // editable: true,
      align: "center",
      render: (text, record) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          {text > 0 ? (
            <Tooltip
              title="View Courses"
              onClick={() => props.handleViewClick(record?.id)}
            >
              <Tag
                color="blue"
                style={{
                  fontSize: "1.15rem",
                  width: "2.5rem",
                  height: "2.5rem",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  fontWeight: "600",
                  padding: 0,
                }}
              >
                {text}
              </Tag>
            </Tooltip>
          ) : (
            <Tag
              color="default"
              style={{
                fontSize: "1.15rem",
                width: "2.5rem",
                height: "2.5rem",
                display: "flex",
                cursor: "not-allowed",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%", // Make it a circle
                fontWeight: "600",
                padding: 0, // Remove padding for a perfect circle
              }}
            >
              {text}
            </Tag>
          )}
        </div>
      ),
    },
    {
      title: capitalizeWords("Last Updated"),
      dataIndex: "updated_at",
      key: "updated_at",
      width: 100, // set width to 150px
      align: "center",
      // editable: true,
      render: (text) => formatDateWithSuffix(text),
    },
    {
      title: capitalizeWords("Created At"),
      dataIndex: "created_at",
      key: "created_at",
      width: 100, // set width to 150px
      align: "center",
      // editable: true,
      render: (text) => formatDateWithSuffix(text),
    },
    ...(updateAuth && props?.ImpersonateAccess
      ? [
          {
            title: capitalizeWords("ACTIONS"),
            dataIndex: "operation",
            width: 80,
            align: "center",
            render: (_, record) => {
              //console.log(record);
              const editable = isEditing(record);
              return editable ? (
                <div>
                  <CheckCircleFilled
                    title="submit"
                    style={{
                      color: "#52c41a",
                      fontSize: "1.8rem",
                      fontWeight: "700",
                    }}
                    onClick={() => onFinish21(record)}
                  />

                  {record?.can_delete ? (
                    <Popconfirm
                      title={
                        props?.active
                          ? "Confirm to Delete"
                          : "Confirm to Restore"
                      }
                      onConfirm={() => {
                        props.active
                          ? deleteRecord(record)
                          : restoreRecord(record);
                      }}
                    >
                      {props.active ? (
                        <>
                          <DeleteTwoTone
                            style={{
                              cursor: "pointer",
                              fontSize: "1.8rem",
                              marginLeft: "0.9rem",
                            }}
                            title="delete"
                            twoToneColor="#eb2f96"
                            onClick={() => {
                              // setNewProduct(false);
                              // handleReset();
                            }}
                          />
                        </>
                      ) : (
                        <>
                          <SwapOutlined
                            style={{
                              cursor: "pointer",
                              fontSize: "1.8rem",
                              marginLeft: "0.9rem",
                            }}
                            // onClick={() => {
                            //   handleDelete(record);
                            // }}
                            title="Restore"
                          />
                        </>
                      )}
                    </Popconfirm>
                  ) : null}
                  <CloseOutlined
                    onClick={() => {
                      cancel();
                    }}
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8rem",
                      marginLeft: "0.9rem",
                    }}
                  />
                </div>
              ) : (
                <>
                  <Tooltip title={`EDIT`}>
                    <div style={{ marginLeft: "2.5px" }}>
                      <EditableImage
                        handleRowClick={handleRowClick}
                        recordId={record}
                        disabled={editingKey !== ""}
                      />
                    </div>
                  </Tooltip>
                </>
              );
            },
          },
        ]
      : []),
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === "manager" ? "select" : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  // const data = [
  //   {
  //     key: "0",
  //     name: "Screen",
  //     platform: "iOS",
  //     version: "10.3.4.5654",
  //     upgradeNum: 500,
  //     creator: "Jack",
  //     createdAt: "Willows",
  //   },
  //   {
  //     key: "1",
  //     name: "Screen 2",
  //     platform: "Android",
  //     version: "11.0.0",
  //     upgradeNum: 1000,
  //     creator: "Jane",
  //     createdAt: "Oak",
  //   },
  //   {
  //     key: "2",
  //     name: "Screen 3",
  //     platform: "Web",
  //     version: "2.1.0",
  //     upgradeNum: 200,
  //     creator: "John",
  //     createdAt: "Maple",
  //   },
  // ];

  //console.log(namingData);

  // eslint-disable-next-line no-unused-vars

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }

  const csrfToken = getCookie("csrftoken");

  const [isUserExists2, setIsUserExists2] = useState(false);
  const handleFormChange2 = async (changedValues, allValues) => {
    if ("entity_id" in changedValues && allValues.entity_id.length > 0) {
      if (allValues.entity_id === initialHirearchy) {
        setIsUserExists2(false);
      } else {
        const response = await Axios.get(
          `/orgstructurecheck/${userInfo.data.organization.id}/?hierarchy=Level1&search=${allValues.entity_id}`
        );
        //console.log(response);
        setIsUserExists2(response.data.exists);
        //console.log(isUserExists2);
      }
    } else {
      setIsUserExists2(false);
    }
  };
  const checkUserExists2 = () => {
    return new Promise(async (resolve, reject) => {
      if (isUserExists2 === undefined) {
        // API call has not completed yet, wait for it to complete and try again
        setTimeout(() => {
          checkUserExists2().then(resolve, reject);
        }, 100);
      } else if (isUserExists2) {
        reject("Client already exists");
      } else {
        resolve();
      }
    });
  };
  const formRef2 = useRef();
  const handleReset = () => {
    formRef2.current.resetFields();
  };
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const onFinish2 = async (values) => {
    //console.log(values);
    for (const key in values) {
      if (values.hasOwnProperty(key)) {
        // Check if the value is undefined
        if (values[key] === undefined) {
          // Update undefined value to null
          values[key] = null;
        }
      }
    }
    values.organization = userInfo.data.organization.id;
    values.created_by = userInfo?.data?.id;
    try {
      await Axios.post("/categorycreate/", values, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      props?.setTop(false);
      handleReset();
      props.CreateSuccessful("Category has been created");
    } catch (err) {
      //console.log(err);
      props.CreateFailed(
        err?.response?.data?.detail || "Category has not been created"
      );
    }
  };

  return (
    <div>
      <Form
        form={form}
        component={false}
        onFinish={onFinish21}
        onValuesChange={handleFormChange2}
        disabled={!props?.ImpersonateAccess}
      >
        <Table
          bordered
          size="small"
          pagination={false}
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          columns={mergedColumns}
          dataSource={props.data}
          scroll={{
            x: 1000,
            y: `${remainingViewportHeight(25)}px`,
          }}
          expandable={{
            expandIcon,
            onExpand: (expanded, record) => {
              setExpandedRowKeys((prevKeys) => {
                if (expanded) {
                  return [...prevKeys, record.id];
                } else {
                  return prevKeys.filter((key) => key !== record.id);
                }
              });
            },
          }}
          rowKey="id"
          expandedRowRender={(record, index) => {
            return (
              <SubCategoryChild
                record={record}
                data={props.data[index]?.second_categories}
                CreateSuccessful={props.CreateSuccessful}
                CreateFailed={props.CreateFailed}
                LoadUser={props.LoadUser}
                active={props.active}
                ImpersonateAccess={props?.ImpersonateAccess}
              />
            );
          }}
          rowClassName={(record, index) =>
            expandedRowKeys.includes(record.id)
              ? "editable-row expanded-row-table-row"
              : "editable-row"
          }
          className="table-container-nocolor"
          style={{ margin: "1rem" }}
        />

        {!props?.top ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "1rem",
            }}
          >
            <Button
              onClick={() => {
                props?.setTop(true);
              }}
              disabled={!props?.ImpersonateAccess}
              style={{
                background: "white",
                fontWeight: "500",
                fontSize: "1.4rem",
                marginLeft: "2rem",
              }}
            >
              <PlusCircleOutlined style={{ color: "purple" }} />
              Add Category
            </Button>

            <Pagination
              size="small"
              showSizeChanger
              onShowSizeChange={props.onShowSizeChange}
              onChange={props.onPageChange}
              pageSizeOptions={["10", "15", "30", "50", "100"]}
              showQuickJumper
              current={props.currentPage}
              defaultPageSize={props.pageSize}
              total={props.itemsLength}
            />
          </div>
        ) : (
          <div
            style={{
              marginLeft: "10rem",
              marginBottom: "2rem",
              width: "100%",
            }}
          >
            <Form onFinish={onFinish2} ref={formRef2} form={form1}>
              <Row gutter={10} style={{ marginLeft: "0.5rem" }}>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <Form.Item
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Category Name is required",
                      },
                    ]}
                  >
                    <Input placeholder="Enter Category Name" name="name" />
                  </Form.Item>
                </Col>

                <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                  <Form.Item>
                    <div>
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{
                          background: "transparent",
                          border: "none",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            style={{
                              width: "1.8rem",
                              height: "1.8rem",
                              borderRadius: "50%",
                              backgroundColor: "#52c41a",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <CheckOutlined
                              title="submit"
                              style={{
                                color: "#fff",
                                fontSize: "1.2rem",
                                fontWeight: "700",
                              }}
                            />
                          </div>
                        </div>
                      </Button>
                      <DeleteTwoTone
                        style={{
                          cursor: "pointer",
                          fontSize: "1.7rem",
                          marginLeft: "0.9rem",
                        }}
                        title="delete"
                        twoToneColor="#eb2f96"
                        onClick={() => {
                          props?.setTop(false);
                          // handleReset();
                        }}
                      />
                    </div>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        )}
      </Form>
    </div>
  );
};

export default CategoryParent;
